// import { useNavigate } from "react-router-dom"
import image from "../../assets/images/unauthorized.png"
import { useMsal } from "@azure/msal-react"

const Unauthorized = () => {
    const { instance } = useMsal();
    const handleADLogout = () => {
        instance.logoutRedirect().catch((error) => console.error(error));
    };

    return (
        <>
            <div className="blocked-container">
                <div>
                    <img src={image} alt="unauthorized" width="50px" />
                    <h3>401 Unauthorized Access</h3>
                    <p>You are not authorized to access this page. Please check your login<br/> credentials or contact the administrator for access.</p>

                    <button onClick={() => handleADLogout() } className="custom-button orange" style={{padding: "12px 16px", margin: "32px auto"}}>Logout</button>
                </div>
            </div>        
        </>
    )
}

export default Unauthorized